import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export const commissionsService = {
  async get(id: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/commissions/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data as { commission: any };
  },

  async getCreatorCommissions(status?: string) {
    const token = localStorage.getItem('accessToken');
    const params = new URLSearchParams();
    params.append('type', 'received'); // Creator receives commissions
    if (status) params.append('status', status);
    
    const res = await axios.get(`${API_BASE_URL}/api/commissions?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  async getPatronCommissions(status?: string) {
    const token = localStorage.getItem('accessToken');
    const params = new URLSearchParams();
    params.append('type', 'requested'); // Patron requests commissions
    if (status) params.append('status', status);
    
    const res = await axios.get(`${API_BASE_URL}/api/commissions?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  async create(data: {
    creatorId: string;
    title: string;
    description: string;
    amount: number;
    deadline?: string;
    referenceFiles?: File[];
  }) {
    const token = localStorage.getItem('accessToken');
    const formData = new FormData();
    
    formData.append('creatorId', data.creatorId);
    formData.append('title', data.title);
    formData.append('description', data.description);
    formData.append('amount', data.amount.toString());
    if (data.deadline) {
      formData.append('deadline', data.deadline);
    }
    if (data.referenceFiles) {
      data.referenceFiles.forEach((file) => {
        formData.append('referenceFiles', file);
      });
    }

    const res = await axios.post(
      `${API_BASE_URL}/api/commissions`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return res.data;
  },

  async accept(id: string, estimatedDelivery?: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.patch(
      `${API_BASE_URL}/api/commissions/${id}/accept`,
      { estimatedDelivery },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  },

  async reject(id: string, reason: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.patch(
      `${API_BASE_URL}/api/commissions/${id}/reject`,
      { reason },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  },

  async start(id: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.patch(
      `${API_BASE_URL}/api/commissions/${id}/start`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  },

  async uploadDeliverable(id: string, formData: FormData) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.post(
      `${API_BASE_URL}/api/commissions/${id}/deliverables`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return res.data;
  },

  async complete(id: string, deliveryNote?: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.patch(
      `${API_BASE_URL}/api/commissions/${id}/complete`,
      { deliveryNote },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  },

  async approve(id: string, rating?: number, review?: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.patch(
      `${API_BASE_URL}/api/commissions/${id}/approve`,
      { rating, review },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  },

  async cancel(id: string, reason: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.patch(
      `${API_BASE_URL}/api/commissions/${id}/cancel`,
      { reason },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  },

  async getAnalyticsSummary() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(
      `${API_BASE_URL}/api/commissions/analytics/summary`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  },
};
